import { TemaCard } from 'src/data/models/TemaCardModel';

export const travelCards: TemaCard[] = [
    new TemaCard(
        'travel35',
        'Travel',
        'phrase',
        '¿Habla inglés?',
        'Do you speak English?',
        'For situations when you need help in English.'
    ),
    new TemaCard(
        'travel1',
        'Travel',
        'word',
        'aeropuerto',
        'airport',
        'Essential when traveling internationally.',
        [
            { spanish: 'vuelo', english: 'flight' },
            { spanish: 'billete', english: 'ticket' },
            { spanish: 'equipaje', english: 'luggage' },
            { spanish: 'pasaporte', english: 'passport' },
            { spanish: 'aduana', english: 'customs' },
        ]
    ),
    new TemaCard(
        'travel3',
        'Travel',
        'sentence',
        'Mi vuelo ha sido cancelado.',
        'My flight has been cancelled.',
        'Helpful when speaking with airline staff.'
    ),
    new TemaCard(
        'travel2',
        'Travel',
        'sentence',
        '¿Dónde recojo mi equipaje?',
        'Where do I pick up my luggage?',
        'Useful at baggage claim.'
    ),

    new TemaCard(
        'travel4',
        'Travel',
        'word',
        'transporte',
        'transportation',
        'Words related to moving between cities or places.',
        [
            { spanish: 'taxi', english: 'taxi' },
            { spanish: 'metro', english: 'subway' },
            { spanish: 'autobús', english: 'bus' },
            { spanish: 'tren', english: 'train' },
            { spanish: 'andén', english: 'platform' },
        ]
    ),
    new TemaCard(
        'travel27',
        'Travel',
        'phrase',
        '¿Dónde está la estación de autobuses?',
        'Where is the bus station?',
        'Use when traveling around the city.'
    ),
    new TemaCard(
        'travel6',
        'Travel',
        'phrase',
        '¿A qué hora sale el tren?',
        'What time does the train leave?',
        'Common question at stations.'
    ),
    new TemaCard(
        'travel5',
        'Travel',
        'phrase',
        '¿Cuánto cuesta el billete?',
        'How much is the ticket?',
        'Use when buying public transport or event tickets.'
    ),

    new TemaCard(
        'travel7',
        'Travel',
        'sentence',
        'Tengo una reserva a nombre de Smith.',
        'I have a reservation under the name Smith.',
        'Used at hotel reception.'
    ),
    new TemaCard(
        'travel8',
        'Travel',
        'word',
        'habitación',
        'room',
        'Common hotel vocabulary.',
        [
            { spanish: 'reserva', english: 'reservation' },
            { spanish: 'llave', english: 'key' },
            { spanish: 'recepción', english: 'front desk' },
        ]
    ),
    new TemaCard(
        'travel9',
        'Travel',
        'phrase',
        '¿Está incluido el desayuno?',
        'Is breakfast included?',
        'Very common hotel question.'
    ),

    new TemaCard(
        'travel10',
        'Travel',
        'sentence',
        '¿Cómo llego al centro de la ciudad?',
        'How do I get to the city center?',
        'Used when asking for navigation help.'
    ),
    new TemaCard(
        'travel11',
        'Travel',
        'sentence',
        '¿Está lejos de aquí?',
        'Is it far from here?',
        'Use when confirming distance.'
    ),

    new TemaCard(
        'travel16',
        'Travel',
        'word',
        'compras',
        'shopping',
        'Common vocabulary related to shopping.',
        [
            { spanish: 'tienda', english: 'store' },
            { spanish: 'mercado', english: 'market' },
            { spanish: 'precio', english: 'price' },
            { spanish: 'descuento', english: 'discount' },
        ]
    ),

    new TemaCard(
        'travel26',
        'Travel',
        'phrase',
        '¿Qué lugares turísticos me recomienda?',
        'What tourist spots do you recommend?',
        'Great for discovering local sights.'
    ),

];
